import { version } from '../../../package.json';

import styles from './index.module.scss';

export const PageFooter = () => {
  const currentDate = new Date().getFullYear();

  return (
    <div className={styles.footer}>
      <div className={styles.footerMessage}>
        <a href='https://aplfintech.com/apollo-currency' target='blank'>
          Official Site
        </a>
        {window.innerWidth < 480 ? <br /> : ' | '}
        <a href='https://support.apollocurrency.com/' target='blank'>
          Technical Support
        </a>
      </div>
      <div className={styles.footerCopyright}>
        Copyright © 2017-{currentDate} Apollo Foundation. Apollo Version: {version}
      </div>
    </div>
  );
};
